import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";

import { useCurrentUserId } from "../../lib/useCurrentUserId";
import {
  type AccountsPricingResponse,
  accountsPricingResponseSchema,
} from "../types/accountPricing";

function getUrl(workplaceId: string) {
  return `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/${workplaceId}/account-pricing`;
}

export function getAccountPricingQueryKey(params: { workplaceId: string }) {
  return [getUrl(params.workplaceId)];
}

export function useAccountsPricing(options: UseGetQueryOptions<AccountsPricingResponse> = {}) {
  const workplaceId = useCurrentUserId();

  if (!isDefined(workplaceId)) {
    throw new Error("workplaceId is required");
  }

  return useGetQuery({
    url: getUrl(workplaceId),
    responseSchema: accountsPricingResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.HOME_HEALTH_ACCOUNTS_PRICING_GET_LIST_FAILURE,
    },
    retry: 0,
    staleTime: 1000 * 60 * 5,
    refetchInterval: 1000 * 60 * 10,
    ...options,
  });
}
